import { track } from '../miniEvents';

import { TRACKING } from './constants';

export const trackChokePoint = (chokePointName: string) =>
  track(TRACKING.MESSAGES.EXPERIMENT_CHOKEPOINT, TRACKING.SCHEMAS.EXPERIMENT_CHOKEPOINT_SCHEMA, {
    name: chokePointName,
  });
